import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { startTableLabels } from './utils/tableLabels';

const root = ReactDOM.createRoot(document.getElementById('root'));
/*
 * Outside App, so a failure while App itself is rendering is still caught.
 * Inside it, a crash in the router or a page's own tree would take the
 * boundary down with it — which is the white screen this exists to stop.
 */
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

/*
 * A chunk that fails outside React's reach.
 *
 * An error boundary only sees failures thrown while rendering. A code-split
 * import that rejects, or a <script> the browser cannot fetch, never reaches
 * it — and after a deploy those are exactly how an old tab breaks. Same
 * one-shot reload, same flag, so a real failure cannot loop.
 */
const RELOAD_KEY = 'tychi:chunk-reloaded';
const looksLikeStaleChunk = (msg) => /ChunkLoadError|Loading chunk [\d]+ failed|Loading CSS chunk|Unexpected token '</i
  .test(String(msg || ''));

const reloadOnce = () => {
  try {
    if (sessionStorage.getItem(RELOAD_KEY)) return;
    sessionStorage.setItem(RELOAD_KEY, '1');
  } catch { /* private mode — reload anyway, the flag is only a guard */ }
  window.location.reload();
};

window.addEventListener('unhandledrejection', (e) => {
  if (looksLikeStaleChunk(e?.reason?.message || e?.reason)) reloadOnce();
});
window.addEventListener('error', (e) => {
  if (looksLikeStaleChunk(e?.message)) reloadOnce();
});

/*
 * Cleared once the app has actually rendered, so the next deploy gets its own
 * single reload rather than being refused because of one months ago.
 */
window.setTimeout(() => {
  try { sessionStorage.removeItem(RELOAD_KEY); } catch { /* ignore */ }
}, 10000);

// Phone tables → cards: copies each column header into its cells' data-label.
startTableLabels();
